import React from 'react';

import { Form, Input, Button, Row, Col, Alert } from 'antd';

// import { useTheme } from 'utils/Theme';
import { ProfileGeneratedProps } from './Profile.props';
import { Container } from './Profile.style';

const ProfileView = (props: ProfileGeneratedProps): JSX.Element => {
  return (
    <Container>
      <Row justify="center" align="middle" style={{ height: '100%' }}>
        <Col span={8}>
          {props.success && (
            <Alert
              message="Password updated successfully"
              type="success"
              style={{ marginBottom: '16px' }}
            />
          )}
          {props.error && (
            <Alert
              message={props.error}
              type="error"
              style={{ marginBottom: '16px' }}
            />
          )}

          <Form
            name="basic"
            initialValues={{ remember: true }}
            onFinish={props.onSubmit}
            onFinishFailed={props.onSubmitFailed}
          >
            <Form.Item
              label="Old Password"
              name="oldPassword"
              rules={[
                { required: true, message: 'Please input your old password!' },
              ]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item
              label="New Password"
              name="newPassword"
              rules={[
                { required: true, message: 'Please input your password!' },
              ]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item>
              <div style={{ textAlign: 'right' }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={props.isSubmitting}
                >
                  Submit
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default ProfileView;
